import classNames from 'classnames';
import React from 'react';

import {loadingIndicatorAttrs} from 'notebook/util/ExportInstrumentation';

interface SpinnerProps {
  classNames?: string;
  light?: boolean;
}

const Spinner = React.memo(
  (props: SpinnerProps): JSX.Element => (
    <div
      aria-label="Loading"
      aria-live="polite"
      className={classNames('spinner', props.classNames, {'spinner-light': props.light})}
      {...loadingIndicatorAttrs()}
      role="status"
    />
  )
);

Spinner.displayName = 'Spinner';

export default Spinner;
